export default "__VITE_PUBLIC_ASSET__745f8d24__"